import type { Finding, QuickWin } from '@smartapply/shared';

interface QuickWinsListProps {
  quickWins: QuickWin[];
  findings: Finding[];
}

/**
 * Lista compacta com numeração mono e dot leaders entre título e tempo.
 * Densidade alta intencional — Quick Wins pedem leitura rápida e priorização.
 */
export function QuickWinsList({ quickWins, findings }: QuickWinsListProps) {
  if (quickWins.length === 0) return null;

  const findingMap = new Map(findings.map((f) => [f.id, f]));

  return (
    <ol className="space-y-0">
      {quickWins.map((qw, i) => {
        const f = findingMap.get(qw.findingId);
        if (!f) return null;
        return (
          <li
            key={qw.findingId}
            className="flex items-baseline gap-3 border-b border-[var(--border-subtle)] py-3 last:border-b-0"
          >
            <span className="font-mono text-[11px] font-semibold uppercase tracking-wider tabular-nums text-[var(--accent-saffron)]">
              Q.{(i + 1).toString().padStart(2, '0')}
            </span>
            <p className="font-sans text-[15px] text-[var(--ink-primary)]">{f.title}</p>
            <span
              aria-hidden
              className="flex-1 translate-y-[-3px] border-b border-dotted border-[var(--border-default)]"
            />
            <span className="font-mono text-xs tabular-nums text-[var(--ink-tertiary)]">
              ~{qw.estimatedTimeMinutes} min
            </span>
          </li>
        );
      })}
    </ol>
  );
}
